import { Component } from '@angular/core';
import { ConclusionOptionModel } from '../../../../core/models/patient/conclusion-list.model';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PatientsService } from '../../../../core/services/patient/patient.service';
import { ApplicationCode } from '../../../../../enums/application-code.enum';
import { ApplicationFiltersModel } from '../../../../core/models/patient/application-filters.model';
import { FormsModule } from '@angular/forms';
import { ToastService } from '../../../../core/services/toast.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-conclusion-options-list',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, TranslateModule],
  templateUrl: './conclusion-options-list.component.html',
  styleUrl: './conclusion-options-list.component.scss',
})
export class ConclusionOptionsListComponent {
  conclusionOptions: ConclusionOptionModel[] = [];
  applicationCode = ApplicationCode;
  deleteModalId: string = '';
  optionListLoading: boolean = true;
  applications: ApplicationFiltersModel[] = [
    {
      id: 1,
      title: this.translate.instant('dermatology'),
      code: 'DERM',
    },
    {
      id: 2,
      title: this.translate.instant('osas'),
      code: 'OSAS',
    },
    {
      id: 3,
      title: this.translate.instant('diabetes'),
      code: 'DIAB',
    },
  ];
  selectedApplicationCode: string = 'DERM';
  languages: { code: string; name: string; query: string }[] = [
    { code: 'en', name: this.translate.instant('lang.english'), query: 'Eng' },
    { code: 'nl', name: this.translate.instant('lang.dutch'), query: 'Dutch' },
    {
      code: 'tr',
      name: this.translate.instant('lang.turkish'),
      query: 'Turkish',
    },
    {
      code: 'fr',
      name: this.translate.instant('lang.french'),
      query: 'French',
    },
    {
      code: 'de',
      name: this.translate.instant('lang.german'),
      query: 'German',
    },
    {
      code: 'es',
      name: this.translate.instant('lang.spanish'),
      query: 'Spanish',
    },
    {
      code: 'it',
      name: this.translate.instant('lang.italian'),
      query: 'Italian',
    },
    {
      code: 'da',
      name: this.translate.instant('lang.danish'),
      query: 'Danish',
    },
    {
      code: 'sv',
      name: this.translate.instant('lang.swedish'),
      query: 'Swedish',
    },
    {
      code: 'no',
      name: this.translate.instant('lang.norwegian'),
      query: 'Norwegian',
    },
    {
      code: 'fi',
      name: this.translate.instant('lang.finnish'),
      query: 'Finnish',
    },
  ];
  selectedLanguage: string = 'en';

  constructor(
    private patientService: PatientsService,
    private toastService: ToastService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.getConclusionOptionList(this.selectedApplicationCode);
  }

  selectApplicationFilter(code: string): void {
    this.selectedApplicationCode = code;
    this.getConclusionOptionList(this.selectedApplicationCode);
  }

  getConclusionOptionList(code: string): void {
    this.patientService.getConclusionOptions(code).subscribe({
      next: (res) => {
        this.conclusionOptions = res;
      },
      complete: () => {
        this.optionListLoading = false;
      },
    });
  }

  deleteConclusionOptionContent(id: string): void {
    this.patientService.deleteConclusionOptionContent(id).subscribe({
      next: () => {
        this.toastService.showToast(
          this.translate.instant('conclusionOptionContentDeleted'),
          'success'
        );

        this.getConclusionOptionList(this.selectedApplicationCode);
      },
    });
  }

  getTitle(conclusionOption: ConclusionOptionModel, langCode: string): string {
    langCode = langCode.charAt(0).toUpperCase() + langCode.slice(1);
    return conclusionOption
      ? (conclusionOption as any)['title' + langCode] || '-'
      : '-';
  }
}
